import { render, staticRenderFns } from "./ReportDisplayBox.vue?vue&type=template&id=16d4bc6a&scoped=true&"
import script from "./ReportDisplayBox.vue?vue&type=script&lang=js&"
export * from "./ReportDisplayBox.vue?vue&type=script&lang=js&"
import style0 from "./ReportDisplayBox.vue?vue&type=style&index=0&id=16d4bc6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4bc6a",
  null
  
)

export default component.exports